module.exports = __webpack_public_path__ + "img/gmail.b775e175.png";